import type * as core from '../../../../../../../core'

const sliceOnClick = (jiraStatusFilter: string) => ({
  '{}': {
    action: {
      '{}': {
        payload: {
          '{}': {
            goto: {
              '{}': {
                variables: {
                  '{}': {
                    jiraStatusFilter,
                    typeFilter: null,
                    assigneeFilter: null,
                    dueDateFilter: null,
                  },
                },
                navigationId: 'requirements-dashboard',
              },
            },
          },
        },
        operation: 'ui.navigate',
      },
    },
  },
})

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Requirements by Jira Status',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Requirements by Jira Status',
                  slices: {
                    '[]': [
                      {
                        '{}': {
                          name: 'To Do',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'toDo',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: sliceOnClick('To Do'),
                        },
                      },
                      {
                        '{}': {
                          name: 'In Progress',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'inProgress',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: sliceOnClick('In Progress'),
                        },
                      },
                      {
                        '{}': {
                          name: 'In Review',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'inReview',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: sliceOnClick('In Review'),
                        },
                      },
                      {
                        '{}': {
                          name: 'Done',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'done',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: sliceOnClick('Done'),
                        },
                      },
                      {
                        '{}': {
                          name: 'Unknown',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'unknown',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: sliceOnClick('Unknown'),
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
    },
  },
  subqueries: {
    toDo: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'To Do',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    inProgress: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'In Progress',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    inReview: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'In Review',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    done: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'Done',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    unknown: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@.': '!jira_status',
                  },
                  'Unknown',
                ],
              },
              {
                '=': [
                  {
                    '@.': '!jira_status',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
  },
}
